module.exports = __webpack_public_path__ + "components/MapControl/svg/Pomnik przyrody nieożywionej.svg?9afea952";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Pomnik przyrody nieożywionej.svg
// module id = 2079
// module chunks = 0